<template>
  <v-dialog
    v-model="examDialog"
    max-width="65%"
    class="units"
    height="70vh"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-stepper class="units" v-model="el">
      <v-stepper-header>
        <v-stepper-step :complete="el > 1" :step="1">
          Exam Centers
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="el > 2" :step="2">
          Book Units
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content :step="1">
          <v-card flat min-height="10vh">
            <v-card-text>
              <v-autocomplete
                :items="examCenters"
                label="Select an Exam Center"
                outlined
                dense
                :item-text="(item) => item.Code + ' - ' + item.Name"
                :item-value="(item) => item.Code"
                v-model="selectedExamCenter"
              />
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" elevation="0" @click="closeDialog">
                Close
              </v-btn>
              <v-btn color="primary" elevation="0" @click="el = 2">
                Next
                <v-icon class="ml-1">mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content :step="2">
          <v-card flat :style="{ backgroundColor: loading ? '#228a422e' : '' }">
            <v-card-text
              class="overflow-y-auto overflow-x-hidden"
              style="max-height: 60vh"
            >
              <v-spacer />
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search for a Unit"
                class="mb-2"
                filled
                single-line
                hide-details
                clearable
              ></v-text-field>
              <div class="d-flex flex-column">
                <v-progress-circular
                  indeterminate
                  class="progress--exams align-self-center"
                  size="70"
                  color="primary"
                  width="5"
                  v-if="loading"
                ></v-progress-circular>
              </div>
              <div class="d-flex flex-column">
                <v-chip-group column class="align-self-center">
                  <v-chip
                    v-for="(i, item) in Object.keys(showExamCenter)"
                    :key="i"
                    color="primary"
                  >
                    {{ i }}
                    <v-divider vertical class="mx-2" />
                    {{ Object.values(showExamCenter)[item] }}
                  </v-chip>
                </v-chip-group>
              </div>
              <v-data-table
                :headers="headers"
                :items="studentUnits"
                :items-per-page="10"
                item-key="unit"
                :search="search"
              >
                <template v-slot:[`item.id`]="{ index }">{{ index + 1 }}</template>
                <template v-slot:[`item.description`]="{ item }">
                  <div class="d-flex">
                    <span class="font-weight-bold">{{ item.unit }}: </span>
                    <span class="ml-2">{{ item.paper }}</span>
                  </div>
                </template>
                <template v-slot:[`item.exempted`]="{ item }">
                  <span v-if="item.exempted === true">YES</span>
                  <span v-else>NO</span>
                </template>
                <template v-slot:[`item.examDate`]="{ item }">
                  <span>{{ formatDate(item.examDate) }}</span>
                </template>
                <template v-slot:[`item.select`]="{ item }">
                  <v-layout>
                    <v-checkbox
                      small
                      @change="removeSelectedUnit(item)"
                      :value="item"
                      :disabled="loading"
                      class="shrink mr-2"
                      v-model="formData.units"
                    ></v-checkbox>
                  </v-layout>
                </template>
              </v-data-table>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text color="error" @click="el = 1">
                <v-icon class="mr1">mdi-arrow-left</v-icon>
                Previous
              </v-btn>
              <v-spacer />
              <v-btn
                color="primary"
                elevation="0"
                @click="proceedToBookingList"
              >
                Finish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import examMixins from "@/packages/exams/examMixins";
import { helper } from "../../dashboard/utils";

export default {
  name: "examUnitsDialog",
  mixins: [examMixins],
  data: function () {
    return {
      el: 1,
      headers: [
        { text: "#S/N", value: "id" },
        { text: "Code", value: "unit" },
        { text: "Description", value: "paper" },
        { text: "Exemptible", value: "exempted" },
        { text: "Exam Date", value: "examDate" },
        { text: "Book", value: "select", sortable: false },
      ],
      formData: {
        examCenter: "",
        units: [],
      },
      search: "",
    };
  },
  props: {
    examUnitsDialogBox: Boolean,
  },
  mounted() {
    Event.$on("ExamBookingPayments", (code) => {
      this.$router.replace({
        name: "ExamBookingPayments",
        params: { code },
      });
    });
  },
  computed: {
    loading() {
      return this.$store.getters["Exam/studentExamGetter"]("unitsLoading");
    },
    examDialog: {
      get() {
        return this.examUnitsDialogBox;
      },
      set(value) {
        this.setExamUnitsModal(value);
      },
    },
    currentProgramme() {
      return this.$store.getters["Exam/studentExamGetter"](
        "programmeRegistration",
      );
    },
    examCenters() {
      return this.$store.getters["Exam/studentExamGetter"]("examCenters");
    },
    showExamCenter() {
      return this.formData.examCenter !== "" &&
        this.examCenters.find((el) => el.Code === this.formData.examCenter)
        ? this.examCenters
            .map((el) => {
              if (el.Code === this.formData.examCenter) {
                return {
                  "Exam Center Code": el.Code,
                  "Exam Center": el.Name,
                };
              }
            })
            .filter((item) => item)
            .shift()
        : {};
    },
    studentUnits() {
      return this.currentProgramme["studentunits"]
        ? this.currentProgramme["studentunits"].filter(
            (el) => el.postedReceiptNo.length === 0,
          )
        : [];
    },
    selectedExamCenter: {
      get() {
        return this.formData.examCenter;
      },
      set(value) {
        this.formData.examCenter = value;
        this.examCenters.filter((item) => item.Code === value)[0];
      },
    },
  },
  methods: {
    setExamUnitsModal(value) {
      this.$emit("setExamUnitsModal", value);
    },
    closeDialog() {
      this.examDialog = false;
    },
    proceedToBookingList() {
      this.$emit(
        "proceedToBookingList",
        this.currentProgramme["transactionID"],
      );
    },
    removeSelectedUnit(unit) {
      if (unit["taken"]) {
        let examBooking = {
          transactionID: this.currentProgramme["transactionID"],
          examCenter: this.formData.examCenter,
          units: [
            {
              unit: unit["unit"],
              taken: false,
              examCenter: this.formData.examCenter,
            },
          ],
        };
        this.$store.dispatch("Exam/removeBooking", { ...examBooking });
      } else {
        let examBooking = {
          transactionID: this.currentProgramme["transactionID"],
          examCenter: this.formData.examCenter,
          units: [
            {
              unit: unit["unit"],
              taken: true,
              examCenter: this.formData.examCenter,
            },
          ],
        };
        this.$store.dispatch("Exam/saveBooking", { ...examBooking });
      }
    },
    formatDate(date) {
      return helper.getDateFormat(date);
    },
  },
  watch: {
    studentUnits() {
      this.formData.examCenter = this.studentUnits
        .filter((el) => el.examCenter.length !== 0)
        .shift().examCenter;
      this.formData.units = [...this.studentUnits.filter((el) => el.taken)];
    },
  },
};
</script>

<style scoped>
.units {
  font-family: "PT Sans Caption", serif;
}
.v-progress-circular.progress--exams {
  position: absolute;
  display: inline-flex;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  top: 50%;
}
</style>
